<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKey"
              @keyup.enter="query"
              type="search"
              placeholder="Search here..."
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="visible = !visible"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <!-- 头部按钮 -->
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="fromLoad('add')"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="visible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_name_cn') || '中文名称'">
              <el-input
                style="width:100%;"
                clearable
                size="small"
                v-model="form.scmCategoryName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_name_en') || '英文名称'">
              <el-input
                style="width:100%;"
                clearable
                size="small"
                v-model="form.scmCategoryEnName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_status') || '是否有效'">
              <el-checkbox-group v-model="form.scmCategoryStatusList">
                <el-checkbox label="Y">{{
                  $l('INDEX.form_label_valid') || '有效'
                }}</el-checkbox>
                <el-checkbox label="N">{{
                  $l('INDEX.form_label_invalid') || '无效'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="onReset">{{
          $l('INDEX.btn_reset_filter ') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="query">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      form: {
        searchKey: '',
        scmCategoryName: '',
        scmCategoryEnName: '',
        scmCategoryStatusList: ['Y']
      }
    }
  },
  methods: {
    closeDialog() {
      this.visible = false
    },
    onReset() {
      this.form = {
        searchKey: '',
        scmCategoryName: '',
        scmCategoryEnName: '',
        scmCategoryStatusList: ['Y']
      }
    },
    fromLoad(val) {
      this.$emit(val)
    },
    query() {
      this.$emit('submit', this.form)
      this.visible = false
    },
    reset() {
      this.onReset()
      this.query()
    }
  },
  created() {
    this.reset()
  }
}
</script>
